export default __webpack_public_path__ + "static/media/tour-2.2ac8c65b.svg";